var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lvmamaConfig" }, [
    _c("div", { staticClass: "profit-box" }, [
      _c("div", { staticClass: "profit" }, [
        _c("div", { staticClass: "title" }, [_vm._v("订单级子菜单")]),
        _c("div", [_vm._v("可见菜单：" + _vm._s(_vm.childMenuTotal) + "个")]),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("viewLvmamaChild")
                  },
                },
              },
              [_vm._v(" 查看 ")]
            ),
            _vm.lvmamaType === "set" && _vm.hasEditRule
              ? [
                  _c("el-divider", { attrs: { direction: "vertical" } }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog("setLvmamaChild")
                        },
                      },
                    },
                    [_vm._v(" 设置子菜单 ")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "profit" }, [
        _c("div", { staticClass: "title" }, [_vm._v("订单级黑名单")]),
        _c("div", [
          _vm._v(
            " 关键词黑名单：" +
              _vm._s(
                _vm.keywordTotal < 1
                  ? "未设置"
                  : _vm.keywordTotal +
                      "个关键词，过滤" +
                      _vm.scenicTotal +
                      "个景区"
              ) +
              " "
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("viewLvmamaKeyword")
                  },
                },
              },
              [
                _vm._v(
                  " 查看" +
                    _vm._s(_vm.lvmamaType === "view" ? "明细" : "") +
                    " "
                ),
              ]
            ),
            _vm.lvmamaType === "set" && _vm.hasEditRule
              ? [
                  _c("el-divider", { attrs: { direction: "vertical" } }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog("setLvmamaKeyword")
                        },
                      },
                    },
                    [_vm._v(" 设置黑名单 ")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "profit brand" },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v("可用景区" + _vm._s(_vm.totalCount) + "个"),
        ]),
        _c(
          "el-form",
          { ref: "searchForm", attrs: { model: _vm.searchForm, inline: "" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: "城市", prop: "region_code" } },
              [
                _c("el-cascader", {
                  staticStyle: { width: "120px" },
                  attrs: {
                    options: _vm.citys,
                    props: {
                      checkStrictly: true,
                      emitPath: false,
                      expandTrigger: "hover",
                    },
                    clearable: "",
                    filterable: "",
                    "popper-class": "city-style",
                  },
                  model: {
                    value: _vm.searchForm.region_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "region_code", $$v)
                    },
                    expression: "searchForm.region_code",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "景区名称（主题）", prop: "product_name" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入景区名称（主题）",
                    clearable: "",
                  },
                  model: {
                    value: _vm.searchForm.product_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "product_name", $$v)
                    },
                    expression: "searchForm.product_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "评级", prop: "place_level" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.searchForm.place_level,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "place_level", $$v)
                      },
                      expression: "searchForm.place_level",
                    },
                  },
                  _vm._l(_vm.levelList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "景区类型", prop: "theme_id" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.searchForm.theme_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "theme_id", $$v)
                      },
                      expression: "searchForm.theme_id",
                    },
                  },
                  _vm._l(_vm.scenicType, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.searchData },
                  },
                  [_vm._v(" 搜索 ")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.searchData("reset")
                      },
                    },
                  },
                  [_vm._v(" 重置 ")]
                ),
                _vm.hasExportRole
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          exportLoading: _vm.exportLoading,
                          type: "success",
                        },
                        on: { click: _vm.exportData },
                      },
                      [_vm._v(" 导出 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "right", "margin-bottom": "10px" } },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-size": _vm.searchForm.pagesize,
                "page-sizes": [10, 20, 30, 40, 50, 100],
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.sizeChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "myTable",
            attrs: {
              "header-cell-style": { background: "#f1f1f1", color: "#333333" },
              data: _vm.tableData,
              height: "58vh",
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "商品信息", prop: "picture", width: "320px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "goods-info-box" }, [
                        _c(
                          "div",
                          { staticClass: "image-box" },
                          [
                            _c(
                              "el-image",
                              {
                                attrs: {
                                  src: scope.row.product_thumb,
                                  "preview-src-list": [scope.row.product_thumb],
                                },
                              },
                              [
                                _c("el-image", {
                                  attrs: {
                                    slot: "error",
                                    src: require("@/assets/none.png"),
                                    "preview-src-list": [
                                      require("@/assets/none.png"),
                                    ],
                                  },
                                  slot: "error",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "text" }, [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v(" " + _vm._s(scope.row.product_name) + " ")]
                          ),
                          _c("div", [
                            _vm._v("ID: " + _vm._s(scope.row.product_id)),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "城市", prop: "place_to_addr" },
            }),
            _c("el-table-column", {
              attrs: { label: "评级", prop: "place_level", width: "80px" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "景区类型",
                prop: "product_theme_name",
                "min-width": "190px",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "门票", prop: "goods_total", width: "80px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.changeTabs(scope.row)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }